import React, {useEffect, useState} from 'react';
import TextField from "../../components/TextField";
import { useCreateComment } from '../../hooks/forms/useCreate';

const AddComment = ({formId,officerId,handleToggle}) => {
    const {mutate: _comment, data, error, isLoading,isSuccess} = useCreateComment();
    const [comment, setComment] = useState('');
    const handleSubmitComment = (e) => {
        e.preventDefault()
        _comment({message:comment,formId,officerId})
    }
    useEffect(()=>{
        if(isSuccess){
            alert("Comment Successfully Uploaded")
            handleToggle()
        }
    },[data,isSuccess])

   useEffect(()=>{
    if(error){
        alert("Error ")
        handleToggle()

    }
   },[data,error])
    

    return (
        <form className=" flex flex-col  justify-between mt-8" onSubmit={handleSubmitComment}>
            <TextField required label='Comment' type='textarea' name='comment'
                       value={comment} onChange={e => setComment(e.target.value)}/>
            <button className=" bg-[#0E86D4] text-white font-medium px-8 py-2 text-md rounded print:hidden mt-4"> Submit </button>
        </form>

    );
};

export default AddComment;